import { LineType } from 'features/seismic-3d/models/enums/LineType';
import { ISeismicCalculatorLineType } from '../interfaces/ISeismicCalculatorLineType';
import { ISurveyMetadata } from '../interfaces/ISurveyMetadata';

export class SeismicCalculatorInline implements ISeismicCalculatorLineType {
    getLineType(surveyMetadata: ISurveyMetadata) {
        return LineType.Inline;
    }

    getMinTrace(surveyMetadata: ISurveyMetadata) {
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.XlineStart;
    }

    getMaxTrace(surveyMetadata: ISurveyMetadata) {
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.XlineEnd;
    }

    getTotalTraces (surveyMetadata: ISurveyMetadata) {
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.XlineEnd - surveyMetadata.Survey3DInfo.XlineStart;
    }

    getMaxLine(surveyMetadata: ISurveyMetadata) {
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.InlineEnd;
    }

    getMinLine(surveyMetadata: ISurveyMetadata) {
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.InlineStart;
    }

    getLineIncrement(surveyMetadata: ISurveyMetadata){
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.XlineIncrement;
    }

    getSkipTrace(surveyMetadata: ISurveyMetadata){
        if (!surveyMetadata.Survey3DInfo){
            return 0;
        }
        return surveyMetadata.Survey3DInfo.InlineIncrement;
    }
}

